import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from './Typography';

/**
 * Banner shown when an entity has a pending scheduled deletion, with an inline action to cancel it.
 */
export default function PendingDeletionBanner({ pendingDeletionDateTime, onCancel, isCancelling, messageKey }) {
   if (!pendingDeletionDateTime) {
      return null;
   }
   const deletionDate = moment(pendingDeletionDateTime);
   const daysRemaining = Math.max(0, Math.ceil(deletionDate.diff(moment(), 'hours') / 24));

   return (
      <Alert severity='warning' sx={{ marginBottom: 2 }}
         action={
            <Button color='inherit' size='small' onClick={onCancel} disabled={isCancelling}>
               <Typography variant='inherit' id={'pendingDeletion.banner.cancelButton'} />
            </Button>
         }>
         <Typography variant='inherit' id={messageKey}
            values={{ days: daysRemaining, date: deletionDate.format('MMMM D, YYYY') }} />
      </Alert>
   );
}

PendingDeletionBanner.propTypes = {
   pendingDeletionDateTime: PropTypes.string, // ISO date string; null/undefined means no banner is rendered.
   onCancel: PropTypes.func.isRequired,       // Called when the admin clicks Cancel.
   isCancelling: PropTypes.bool,              // Disables the cancel button while the cancel mutation is in flight.
   messageKey: PropTypes.string.isRequired,   // Localization key for the banner message ({date}, {days} values).
};
